import loadable from '@loadable/component';
import { Navigate } from 'react-router';
import { OverlaySpinner } from '@ankr.com/ui';

import { LoggingInGuard } from 'modules/auth/components/LoggingInGuard';
import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { Page } from 'modules/layout/components/Page';
import { chainsRoutesConfig } from 'domains/chains/routes';

const NewsPage = loadable(
  () => import('./NewsPage').then(module => module.NewsPage),
  {
    fallback: <OverlaySpinner />,
  },
);

const chainsList = chainsRoutesConfig.chains.generatePath();

export const NewsPageContainer = () => {
  return (
    <NoSSRGuard>
      <Page>
        <LoggingInGuard fallback={<Navigate to={chainsList} />}>
          <NewsPage />
        </LoggingInGuard>
      </Page>
    </NoSSRGuard>
  );
};
